import Section from '../../../components/section'

import MetadataContent from './metadata'
import SubscriptionsContent from './subscriptions'

const AdminTab = () => {
  const initialProps = { isEditing: false, setIsEditing: () => {} }

  return (
    <>
      <Section component={<SubscriptionsContent {...initialProps} />} title="Subscriptions" />
      <Section component={<MetadataContent {...initialProps} />} title="Metadata" />
    </>
  )
}

export default AdminTab
